import React, {useContext, useState, useEffect} from 'react'
import { GoogleMap, useJsApiLoader, Marker, InfoBox  } from '@react-google-maps/api';
import Layout from '../../components/Layout'
import { UseGeoLocation} from '../../hooks/GeoLocation/useGeoLocation'
import { UserContext } from '../../context api/UserContext'
import { doc, onSnapshot } from "firebase/firestore";
import { collection, getDoc, getDocs, query, where  } from 'firebase/firestore'
import { db } from '../../lib/firebase-config'


const containerStyle = {
  width: '100%',
  height: '500px',
  marginLeft: "50px",
  margin: "0 auto", 
  textAlign: "center",
};

const center = {lat: 28.5767356, lng: 77.316791}


const layoutProps = {
  heading: 'Employee Tracking',
}
function GeoLocation({lat, lng}) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "YOUR_API_KEY"
  })

  const [map, setMap] = React.useState(null)
  const [isOpen, setOpen ] = React.useState(false);
  const [values, setValues] = React.useState({})
  const { getGeos } = UseGeoLocation();
  const {user, company} = useContext(UserContext)

  React.useEffect(()=>{
    console.log(user);
    let companyAdminId = user.companyAdminId
    if(user.userType === "COMPANYADMIN"){
      companyAdminId = user._id
      let path = `geoLocation/${companyAdminId}`
      console.log("path", path)
      // const q = query(collection(db, path));
      const unsub = onSnapshot(doc(db, "geoLocation", companyAdminId), (doc) => {
        console.log("Current data: ", doc.data());
    });
    
      
      // const hello = fdb.collection("geoLocation").document(companyAdminId).get();
      // console.log(hello);
    }else{
      let path = `geoLocation/${companyAdminId}/${user._id}`
      console.log("path", path)
      const q = query(collection(db, path));
      console.log(q.size);
      const unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          console.log(change.type)
          console.log(change.doc.data())
          let docD = change.doc.data();
          console.log(docD)
          setValues((values)=>{ return{...values, [docD.employeeId] : {employeeId: docD.employeeId, lat: docD.lat[docD.lat.length - 1], lng: docD.lng[docD.lat.length - 1], timestamp: docD.timestamp[docD.lat.length -1]}}})
        });
        
      });
    }
    
  }, [])
  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  const onMarkerClick = () => {
    setOpen(!isOpen);
  }
  return isLoaded ? (
      <Layout {...layoutProps}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={10}
          onLoad={onLoad}
          onUnmount={onUnmount}
        >
          {console.log({values})}
          {Object.keys(values).map((key, index)=>{
            const cntr = {lat: values[key].lat, lng: values[key].lng }
            console.log("key", {key}, cntr)
            return (
              <Marker position= {cntr} onClick={onMarkerClick} key = {key} >
              {isOpen &&
                <InfoBox
                  onCloseClick={()=>setOpen(!isOpen)}
                >
                  <div style={{ backgroundColor: `white`, opacity: 1, padding: `10px`, borderRadius: "4px" }}>
                    <div style={{ fontSize: `14px`, fontColor: `#08233B` }}>
                      {values[key].name!== undefined ? values[key].name : values[key].employeeId }!
                    </div>
                  </div>
                </InfoBox>
              }
            </Marker>
            )
          })}
      
        </GoogleMap>
      </Layout> 
 
    
  ) : <></>
}

export default React.memo(GeoLocation)